import { RoleEnum } from "../models/enums";
import { useAuthenticatedUser } from "./useAuthenticatedUser";
import { useCheckForRoot } from "./useCheckForRoot";

const usePlateManagementNavigationRoute = () => {
  const isRootRole = useCheckForRoot();
  const { role } = useAuthenticatedUser();

  const allowedAminRoles = [
    RoleEnum.PARTNER_ADMIN,
    RoleEnum.CC_OPS,
    RoleEnum.CC_OPS_ADMIN,
    RoleEnum.CUSTOMER_ADMIN,
  ];

  const getNavigationRoute = (rootPath: string, userPath: string): string => {
    let navRoute: string;

    if (isRootRole || allowedAminRoles.includes(role)) {
      navRoute = rootPath;
    } else {
      navRoute = userPath;
    }

    return navRoute;
  };

  return { getNavigationRoute };
};

export default usePlateManagementNavigationRoute;
